import { DriverStatus } from "./driverstatus";
import { SensorEvent } from "./sensorEvent";

export class VehicleState {
    id: string;
    createDateTimeUtc: Date;
    updateDateTimeUtc: Date;
    statusUpdateDateTimeUtc: Date;
    locationUpdateDateTimeUtc: Date;
    sensorUpdateDateTimeUtc: Date;
    vin: string;
    odometer: number;
    dashboard: any;
    cruiseState: any;
    ecmSpeed: number;
    position: any;
    velocity: any;
    engine: any;
    faults: any;
    sensors: SensorEvent[];
    driverStatusList: DriverStatus[];
    constructor() {
        this.vin = '';
        this.odometer = 0;
        this.dashboard = {};
        this.cruiseState = {};
        this.ecmSpeed = 0;
        this.position = {};
        this.velocity = {};
        this.engine = {};
        this.faults = {};
        this.sensors = new Array<SensorEvent>();
        this.driverStatusList = new Array<DriverStatus>();
    }
}